import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { MenuMobileOpendListStyles } from '../components/Navbar.styles';

function MobileMenu() {
  return (
    <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
      <div className="offcanvas-header">
        <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close" />
      </div>
      <div className="offcanvas-body">
        <MenuMobileOpendListStyles className="list-group list-group-flush">
          <li className="list-group-item">
            <Link to="/soluzioni" className="text-decoration-none text-dark">
              Soluzioni
            </Link>
          </li>
          <li className="list-group-item">
            <Link to="/blog" className="text-decoration-none text-dark">
              Blog
            </Link>
          </li>
          <li className="list-group-item">
            <Link to="/collabora-con-noi" className="text-decoration-none text-dark">
              Collabora Con Noi
            </Link>
          </li>
          <li className="list-group-item">
            <Link to="/servizio-whatsapp" className="text-decoration-none text-dark">Servizio WhatsApp</Link>
          </li>
          {/* <li className="list-group-item">
            <Link to="/team" className="text-decoration-none text-dark">
              Team
            </Link>
          </li> */}
          <li className="list-group-item">
            <a
              href="https://intermediari.greenia.it"
              target="_blank"
              className="bookmarkBtnBroker text-decoration-none"
              rel="noreferrer"
            >
              <span className="IconContainerBroker">
                <FaArrowRight className="text-dark" />
              </span>
              <p className="text-broker m-0 me-2">Area Intermediari</p>
            </a>
          </li>
          <li className="list-group-item">
            <Link
              to="/login"
              className="bookmarkBtn text-decoration-none"
              rel="noreferrer"
            >
              <span className="IconContainer">
                <FaArrowRight className="text-white" />
              </span>
              <p className="text m-0 me-2">Area Clienti</p>
            </Link>
          </li>
        </MenuMobileOpendListStyles>
      </div>
    </div>
  );
}

export default MobileMenu;
